import { PriceFormat } from "projects/shared/lib/components/shared/price/format/price-format.model";
import { EPriceMark, EProductPriceType } from "projects/shared/lib/services/INTEGRA_Shop_Client";

export class PriceTemplateData {

  public listUnitPrice?: PriceFormat;
  public listPricePerPriceQuantity?: PriceFormat;

  public customUnitPrice?: PriceFormat;
  public customPricePerPriceQuantity?: PriceFormat;

  public scaleUnitPrice?: PriceFormat;
  public scalePricePerPriceQuantity?: PriceFormat;

  public orderUnitPrice?: PriceFormat | undefined;
  public orderPricePerPriceQuantity?: PriceFormat | undefined;

  /** Specifies which price should be displayed as the order price */
  public orderPriceType?: EProductPriceType | undefined;
  /** Specifies whether the order price is for a single unit or not */
  public orderPriceIsUnitPrice?: boolean | undefined;

  /** Specifies which price should be displayed above the order price as reference */
  public referencePriceType?: EProductPriceType | undefined;
  /** Specifies whether the referenced price above the order price is for a single unit or not */
  public referencePriceIsUnitPrice?: boolean | undefined;

  /** Specifies whether a price other than "list"(Shop local) is provided */
  public hasCustomerPrice?: boolean;
  /**
   * Specifies whether the given order(customer) price differs from the list price.
   * Only true if both list and order price are found and not equal in result net prices.
   */
  public hasDifferentListAndOrderPrices?: boolean;
  /** Specifies whether the base price is higher than the order price in case both are present. */
  public listPriceIsHigherThanOrderPrice?: boolean;
  /** Specifies of which price mark the current valid selected order price is. */
  public orderPriceMark?: EPriceMark | undefined;
}
